import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Button, DatePicker, Select, Input, Tooltip, Icon } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import DateRange from '../../common/DateRange.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import moment from 'moment';

const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';
const { RangePicker } = DatePicker;

class SiteInGroupRate extends Component {
    constructor(props) {
        super(props);
        const { settlementType } = props;
        this.state = {
            data: [],
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
            },
            searchParams: {
                settlementType,
                statisticalMethod: 'WEEK',
                startWeekDay: moment().subtract(7, 'w').startOf('week').format(dateFormat),
                endWeekDay: moment().endOf('week').format(dateFormat),
            },
        }
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.settlementType !== prevProps.settlementType) {
            const { searchParams } = this.state;
            searchParams.settlementType = this.props.settlementType;
            this.setState({ searchParams }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.queryInvestigationSiteGroupSpeedTrend,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dateType: 'json',
            doneResult: res => {
                const { totalCount, datas = [] } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    loading: false,
                    data: datas || [],
                });
            }
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        })
    }

    export = () => {
        const { pagination, searchParams } = this.state;
        const url = API_URL.summary.exportInvestigationSiteGroupSpeedTrend;
        ExportUtil.export({ ...searchParams }, pagination, url);
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key == 'statisticalMethod') {
            if (value == 'WEEK') {
                searchParams.endMonth = undefined;
                searchParams.startMonth = undefined;
                searchParams.startWeekDay = moment().subtract(7, 'w').startOf('week').format(dateFormat);
                searchParams.endWeekDay = moment().endOf('week').format(dateFormat);
            } else {
                searchParams.endWeekDay = undefined;
                searchParams.startWeekDay = undefined;
                searchParams.startMonth = moment().subtract(11, 'M').format(monthFormat);
                searchParams.endMonth = moment().format(monthFormat);
            }
        }
        this.setState({ searchParams });
    }

    handleDateChange = (value) => {
        const { searchParams } = this.state;
        const [begin, end] = value;
        searchParams.startMonth = begin;
        searchParams.endMonth = end;
        this.setState({ searchParams });
    }

    handleRangeChange = (dates, dateStrings) => {
        const { searchParams } = this.state;
        const [ startDay, endDay ] = dateStrings;
        searchParams.startWeekDay = startDay ? moment(startDay).startOf('week').format(dateFormat) : '';
        searchParams.endWeekDay = endDay ? moment(endDay).endOf('week').format(dateFormat) : '';
        this.setState({ searchParams });
    }

    getColumns = () => {
        const { data } = this.state;
        const monthList = (data && data.length && data[0].groupSpeedValueList) || [];
        const isFixed = monthList.length > 7 && 'left'
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 85,
            fixed: isFixed,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            width: 100,
            fixed: isFixed,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
            fixed: isFixed,
        }];

        if (monthList.length) {
            monthList.forEach(item => {
                columns.push({
                    title: item.title,
                    dataIndex: item.title,
                    key: item.title,
                    width: 90,
                });
            });
        }
        return columns;
    }

    getdataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        let dataSource = [];
        data.forEach((item, index) => {
            const params = {
                index: (current - 1) * pageSize + index + 1,
                investigationSiteName: item.investigationSiteName,
                investigationSiteCode: item.investigationSiteCode,
            };
            if (item.groupSpeedValueList && item.groupSpeedValueList.length) {
                item.groupSpeedValueList.forEach(i => {
                    params[i.title] = i.value;
                });
            }
            dataSource.push(params);
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    render() {
        const {
            loading,
            pagination,
            searchParams: {
                startMonth,
                endMonth,
                startWeekDay,
                endWeekDay,
                settlementType,
                statisticalMethod,
                investigationSiteName,
                investigationSiteCode,
            }
        } = this.state;
        const newStartWeekDay = startWeekDay ? moment(startWeekDay) : null;
        const newEndWeekDay = endWeekDay ? moment(endWeekDay) : null;
        const tipInfo = (
            <span>
                1、自然月，表示每月统计的数据范围，<br />
                为本月1号~月底产生的数据。<br />
                2、工时结算月，表示每月统计的数据<br />
                范围，为上月26号~本月25号产生的数据。
            </span>
        );
        return (
            <div className="content primary-tabs-active">
                <SideNav selectKey='/summary/siteGroupingRate' />
                <div className="main">
                    <Spin spinning={loading}>
                        <div className="T-tit">
                            <div className="txt">
                                <h3 style={{ marginBottom: 10 }}>各中心入组速率趋势</h3>
                            </div>
                        </div>
                        <div style={{ marginBottom: 20 }}>
                            <Select
                                value={statisticalMethod}
                                style={{width: 80, marginRight: 10}}
                                onChange={value => this.handleSelectChange(value, 'statisticalMethod')}
                            >
                                <Option value="WEEK">按周统计</Option>
                                <Option value="MONTH">按月统计</Option>
                            </Select>
                            {
                                statisticalMethod === 'WEEK' ?
                                    <RangePicker
                                        style={{width: 240, verticalAlign: 'middle'}}
                                        onChange={this.handleRangeChange}
                                        value={[newStartWeekDay, newEndWeekDay]}
                                        format={dateFormat}
                                    />
                                :
                                    <div style={{ display: 'inline-block'}}>
                                        <span style={{marginRight: 10}}>统计维度:</span>
                                        <Select style={{marginRight: 10, width: 110}} value={settlementType} onChange={value => this.handleSelectChange(value, 'settlementType')}>
                                            <Option value='BILLING_MONTH'>按工时结算月</Option>
                                            <Option value='NATURAL_MONTH'>按自然月</Option>
                                        </Select>
                                        <Tooltip placement="top" title={tipInfo}>
                                            <a><Icon style={{ marginRight: 10, fontSize: '14px', color: '#5750c9' }} type="info-circle" /></a>
                                        </Tooltip>
                                        <DateRange
                                            separator="~"
                                            allowClear={false}
                                            value={[startMonth, endMonth]}
                                            style={{width: 100}}
                                            disabledDate={[11, 'M']}
                                            onChange={this.handleDateChange}
                                        />
                                    </div>
                            }
                            <div style={statisticalMethod === 'WEEK' ? { display: 'inline-block' } : { display: 'block', marginTop: 10}}>
                                <span style={{ margin: '0 10px' }}>中心编号</span>
                                <Input
                                    style={{width: 120}}
                                    placeholder="请输入"
                                    onChange={(e) => this.handleInputChange(e, 'investigationSiteCode')}
                                    value={investigationSiteCode}
                                />
                                <span style={{ margin: '0 10px' }}>中心名称</span>
                                <Input
                                    style={{width: 120}}
                                    placeholder="请输入"
                                    onChange={(e) => this.handleInputChange(e, 'investigationSiteName')}
                                    value={investigationSiteName}
                                />
                                <Button type='primary' style={{ marginLeft: 10 }} onClick={this.search}>搜索</Button>
                                <Button type='primary' style={{ marginLeft: 10 }} onClick={this.export}>导出</Button>
                            </div>
                        </div>
                        <div className="content">
                            <TableC
                                className="siteInGroupRate"
                                pagination={pagination}
                                data={this.getdataSource()}
                                columns={this.getColumns()}
                                onChange={this.handleTableChange}
                            />
                        </div>
                    </Spin>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { inProjectState: { settlementType } } = state;
    return {
        settlementType,
    };
};

export default connect(mapStateToProps, null)(SiteInGroupRate);


// WEBPACK FOOTER //
// ./src/components/summary/siteInGroupRate/index.js